import React from 'react';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';

import './IconButtonMUI.scss';
import Tooltip from '@material-ui/core/Tooltip';

const IconButtonMUI = ({
  children,
  className = '',
  color = 'default',
  component = 'button',
  disabled = false,
  disableFocusRipple = false,
  disableRipple = false,
  edge = false,
  loading = false,
  size = 'medium',
  onClick,
  to,
  title = '',
  ...props
}) => (
  <Tooltip title={title} arrow>
    {/* Wrap IconButton with Tooltip */}
    <IconButton
      className={className}
      classes={{
        root: 'icon-button-mui',
        edgeStart: 'icon-button-mui--edge-start',
        edgeEnd: 'icon-button-mui--edge-end',
        colorPrimary: 'icon-button-mui--color-primary',
        colorSecondary: 'icon-button-mui--color-secondary',
        colorInherit: 'icon-button-mui--color-transparent',
        disabled: 'icon-button-mui--disabled',
        sizeSmall: 'icon-button-mui--size-small',
        label: 'icon-button-mui__label'
      }}
      color={color}
      component={component}
      to={to}
      disabled={disabled || loading}
      disableFocusRipple={disableFocusRipple}
      disableRipple={disableRipple}
      edge={edge}
      size={size}
      onClick={onClick}
      {...props}
    >
      {loading ? (
        <svg className='spinner' width='24' height='24' viewBox='0 0 50 50'>
          <circle className='path' cx='25' cy='25' r='20' fill='none' strokeWidth='5' />
        </svg>
      ) : (
        children
      )}
    </IconButton>
  </Tooltip>
);

IconButtonMUI.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  color: PropTypes.oneOf(['default', 'primary', 'secondary', 'inherit']),
  component: PropTypes.elementType,
  disableFocusRipple: PropTypes.bool,
  disableRipple: PropTypes.bool,
  disabled: PropTypes.bool,
  edge: PropTypes.oneOf(['start', 'end', false]),
  onClick: PropTypes.func,
  size: PropTypes.oneOf(['small', 'medium']),
  to: PropTypes.string,
  loading: PropTypes.bool
};

export default IconButtonMUI;
